import { TacticsData, Tactics } from "../../types/data";
import { gamePrediction } from "./data";

export const getGamePrediction = async (
  tacticsData: TacticsData
): Promise<number[]> => {
  const returnData = await gamePrediction(tacticsData);
  const homeWin = returnData["home_away_probs"][0] * 100;
  const awayWin = returnData["home_away_probs"][1] * 100;
  return [homeWin, awayWin];
};

export const getMetricString = (metric: Tactics): string => {
  if (metric === "transition") {
    return "Transition";
  } else if (metric === "off ball screen inside") {
    return "Off-ball Screen Inside";
  } else if (metric === "off ball screen outside") {
    return "Off-ball Screen Outside";
  } else if (metric === "on ball screen inside") {
    return "On-ball Screen Inside";
  } else if (metric === "on ball screen outside") {
    return "On-ball Screen Outside";
  } else {
    return "Isolation";
  }
};

export const createDisplayData = (tacticsData: TacticsData) => {
    const newData = {...tacticsData};
    for (const [key, value] of Object.entries(newData)) {
      for (const [innerKey, innerValue] of Object.entries(value)) {
        innerValue.lock = [false, false];
      }
    }
    return newData;
  };
